import Checkbox, { CheckboxProps } from "./Checkbox/Checkbox";
import Date, { DateProps } from "./Date/Date";
import Dropdown, { DropdownProps } from "./Dropdown/Dropdown";
import Email, { EmailProps } from "./Email/Email";
import File, { FileProps } from "./File/File";
import Number, { NumberProps } from "./Number/Number";
import Phone, { PhoneProps } from "./Phone/Phone";
import Terms, { TermsProps } from "./Terms/Terms";
import Text, { TextProps } from "./Text/Text";
import React from "react";
export type InputElement = HTMLInputElement & HTMLSelectElement & HTMLTextAreaElement;
export type DropdownOption = {
  optionId: string;
  value: string;
};
export type SharedInputProps = React.InputHTMLAttributes<HTMLInputElement> & {
  error?: string;
  helpText?: string;
  label?: React.ReactNode;
  options?: DropdownOption[];
  selectedOption?: string;
};
type InputProps = (CheckboxProps & {
  variant: "checkbox";
}) | (DateProps & {
  variant: "date";
}) | (DropdownProps & {
  variant: "dropdown";
}) | (EmailProps & {
  variant: "email";
}) | (FileProps & {
  variant: "file";
}) | (NumberProps & {
  variant: "number";
}) | (PhoneProps & {
  variant: "phone";
}) | (TermsProps & {
  variant: "terms";
}) | (TextProps & {
  variant: "text";
});
export function Input({
  variant,
  ...props
}: InputProps) {
  /**
   * Need to cast props as the relevant type because typescript isn't smart
   * enough to figure out the separation of prop types here. But in practice
   * the typing of InputProps and the individual component prop types is safe
   * and typescript will complain if an input is rendered with the wrong
   * combination of variant and props.
   */
  switch (variant) {
    case "checkbox":
      return <Checkbox {...props as CheckboxProps} />;
    case "date":
      return <Date {...props as DateProps} />;
    case "dropdown":
      return <Dropdown {...props as DropdownProps} />;
    case "email":
      return <Email {...props as EmailProps} />;
    case "file":
      return <File {...props as FileProps} />;
    case "number":
      return <Number {...props as NumberProps} />;
    case "phone":
      return <Phone {...props as PhoneProps} />;
    case "terms":
      return <Terms {...props as TermsProps} />;
    case "text":
      return <Text {...props as TextProps} />;
  }
}
export default Input;